import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import Navbar from '../../components/Navbar/Navbar';
import Hero2 from '../../components/hero2/Hero2';
import ProcessSection from '../../components/ProcessSection/ProcessSection';
import About2 from '../../components/about2/about2';
import ServiceSection2 from '../../components/ServiceSection2/ServiceSection2';
import ProjectSectionS2 from '../../components/ProjectSectionS2/ProjectSectionS2';
import Testimonial from '../../components/Testimonial/Testimonial';
import FunFactS2 from '../../components/FunFactS2/FunFactS2';
import TeamSection from '../../components/TeamSection/TeamSection';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/Horizontal-Logo-white.png'

const HomePage2 = () => {
    const SITE_URL = 'https://pharmacyfreedomfund.com';
    const schema = [
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": `${SITE_URL}/` },
                { "@type": "ListItem", "position": 2, "name": "For Pharmacies", "item": `${SITE_URL}/for-pharmacies` }
            ]
        },
        {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "For Pharmacies",
            "url": `${SITE_URL}/for-pharmacies`
        }
    ];
    return (
        <Fragment>
            <SEO
                title="For Pharmacies"
                description="Get capital and operational support to grow your independent pharmacy. Partner with Pharmacy Freedom Fund to modernize, hire, and expand services."
                keywords={["pharmacy funding", "independent pharmacy support", "pharmacy growth", "healthcare operations", "pharmacy capital"]}
                canonical="https://pharmacyfreedomfund.com/for-pharmacies"
                schema={schema}
            />
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <Hero2 />
            <ServiceSection2 hclass={'service_section_s2 section-padding'} />
            <About2 />
            <Testimonial tClass={'testimonial_section testimonial_section_slider section-padding'} />
            <Footer hclass={'wpo-site-footer_s2'} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage2;